import { Box, Text, HStack, VStack, Icon, Spinner } from '@chakra-ui/react';
import { MdRefresh, MdChevronRight } from 'react-icons/md';
import Sheet from '@/components/Sheet';
import { RecipeService } from '@/lib/recipeService';
import { CollectionService } from '@/lib/collectionService';

interface SettingsSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SettingsSheet({ isOpen, onClose }: SettingsSheetProps) {
  const menuItems = [
    {
      icon: MdRefresh,
      label: 'Refresh app data',
      description: 'Clear the local cache and reload recipes and collections',
      loading: false,
      action: () => {
        onClose();
        void RecipeService.reset();
        void CollectionService.reset();
      },
    },
  ];

  return (
    <Sheet isOpen={isOpen} onClose={onClose} zIndex={160}>
      <Box px={5} pb={5}>
        <Text
          fontFamily="heading"
          fontWeight="800"
          fontSize="16px"
          color="text.primary"
          py={4}
          mb={2}
          borderBottom="1px solid"
          borderColor="border.muted"
        >
          Settings
        </Text>

        <VStack gap={2} align="stretch" mt={3}>
          {menuItems.map((item) => (
            <HStack
              key={item.label}
              gap={3}
              p={3}
              bg="bg.canvas"
              border="1px solid"
              borderColor="border.muted"
              borderRadius="12px"
              cursor={item.loading ? 'default' : 'pointer'}
              opacity={item.loading ? 0.6 : 1}
              onClick={() => void item.action()}
              _hover={{ bg: item.loading ? 'bg.canvas' : 'bg.muted' }}
              transition="background 0.15s"
            >
              <Box
                w="36px" h="36px"
                borderRadius="9px"
                bg="bg.muted"
                display="flex" alignItems="center" justifyContent="center"
                flexShrink={0}
              >
                <Icon as={item.icon} boxSize={4.5} color="text.muted" />
              </Box>
              <Box flex={1} minW={0}>
                <Text fontFamily="body" fontWeight="500" fontSize="13px" color="text.primary">
                  {item.label}
                </Text>
                {item.description && (
                  <Text fontFamily="body" fontWeight="300" fontSize="11px" color="text.muted" mt="1px">
                    {item.description}
                  </Text>
                )}
              </Box>
              {item.loading
                ? <Spinner size="sm" color="text.muted" flexShrink={0} />
                : <Icon as={MdChevronRight} boxSize={4} color="text.muted" flexShrink={0} />
              }
            </HStack>
          ))}

        </VStack>
      </Box>
    </Sheet>
  );
}
